import { api } from './api';
import {
  NotificationsResponse
} from '../types/notification';

export interface ServerNotificationPreferences {
  likes: boolean;
  comments: boolean;
  follows: boolean;
  mentions: boolean;
  systemNotifications: boolean;
}

class NotificationApi {
  /**
   * Fetch user notifications with pagination
   */
  async getNotifications(page = 1, limit = 20): Promise<NotificationsResponse['data']> {
    const response = await api.get<NotificationsResponse['data']>('/notifications', {
      params: { page, limit }
    });
    return response.data;
  }

  /**
   * Mark a notification as read
   */
  async markAsRead(id: string): Promise<void> {
    await api.put(`/notifications/${id}/read`);
  }

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    await api.put('/notifications/read-all');
  }

  /**
   * Delete a notification
   */
  async deleteNotification(id: string): Promise<void> {
    await api.delete(`/notifications/${id}`);
  }

  /**
   * Delete all notifications
   */
  async deleteAllNotifications(): Promise<void> {
    await api.delete('/notifications');
  }

  /**
   * Get notification preferences from server
   */
  async getPreferences(): Promise<ServerNotificationPreferences> {
    const response = await api.get<{ preferences: ServerNotificationPreferences }>('/notifications/preferences');
    return response.data.preferences;
  }

  /**
   * Update notification preferences on server
   */
  async updatePreferences(preferences: Partial<ServerNotificationPreferences>): Promise<void> {
    await api.put('/notifications/preferences', preferences);
  }
}

// Export singleton instance
export const notificationApi = new NotificationApi();


